import { canonicalUrl } from "../site";
import { DENIED, cleanVendorStorage } from "./storage";
import { EMPTY_TRACKING, configKey, validTracking } from "./config";
import { googleConsent, hasVendorScripts, loadGoogle, loadMeta, loadTikTok } from "./vendors";

let config = EMPTY_TRACKING;
let consent = DENIED;
let path = "/";
const configured = new Set();
const lastPage = {};
export const trackingHasStarted = hasVendorScripts;
const adsReady = () => config.google_ads_id && config.google_ads_label;

export const revokeTracking = (next = DENIED) => {
    const revoked = (consent.analytics && !next.analytics) || (consent.marketing && !next.marketing);
    consent = next;
    if (window.gtag) window.gtag("consent", "update", googleConsent(next));
    if (config.ga4_id) window[`ga-disable-${config.ga4_id}`] = !next.analytics;
    if (!next.marketing) { window.fbq?.("consent", "revoke"); window.ttq?.revokeConsent?.(); window.ttq?.disableCookie?.(); }
    cleanVendorStorage({ analytics: !next.analytics, marketing: !next.marketing });
    return revoked && hasVendorScripts();
};

export const configureTracking = (raw, choices, pathname) => {
    const nextConfig = validTracking(raw);
    const next = nextConfig.enabled && !pathname.startsWith("/scrivi") ? choices : DENIED;
    const changedLoadedConfig = hasVendorScripts() && configKey(config) !== configKey(nextConfig);
    if (changedLoadedConfig || ((consent.analytics && !next.analytics) || (consent.marketing && !next.marketing))) {
        const reload = revokeTracking(next);
        if (changedLoadedConfig || reload) return true;
    }
    config = nextConfig; consent = next; path = pathname;
    const googleId = consent.analytics && config.ga4_id ? config.ga4_id : consent.marketing && adsReady() ? config.google_ads_id : "";
    if (googleId) {
        loadGoogle(googleId, consent);
        const destinations = [consent.analytics && config.ga4_id, consent.marketing && adsReady() && config.google_ads_id].filter(Boolean);
        destinations.forEach((id) => {
            if (configured.has(id)) return;
            window.gtag("config", id, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: consent.marketing, page_location: canonicalUrl(path), page_referrer: "" });
            configured.add(id);
        });
    }
    if (consent.marketing && config.meta_pixel_id) loadMeta(config.meta_pixel_id);
    if (consent.marketing && config.tiktok_pixel_id) loadTikTok(config.tiktok_pixel_id);
    pageView();
    return false;
};

const onceOnPage = (vendor, callback) => {
    if (lastPage[vendor] === path) return;
    callback(); lastPage[vendor] = path;
};
const gaEvent = (name, extra = {}) => {
    if (consent.analytics && config.enabled && config.ga4_id && window.gtag) {
        window.gtag("event", name, { ...extra, send_to: config.ga4_id, page_location: canonicalUrl(path), page_referrer: "" });
    }
};
const pageView = () => {
    if (consent.analytics && config.ga4_id) onceOnPage("ga", () => gaEvent("page_view"));
    if (consent.marketing && config.meta_pixel_id) onceOnPage("meta", () => window.fbq?.("track", "PageView"));
    if (consent.marketing && config.tiktok_pixel_id) onceOnPage("tiktok", () => window.ttq?.page?.());
};

export const measureEvent = (name, parameters = {}) => {
    const allowed = ["form_submit", "header_cta_click", "block_zero_skip", "scroll_patto", "share", "subscribe", "esempio_download", "anteprima_page"];
    if (!allowed.includes(name) || path.startsWith("/scrivi")) return;
    // Nessun dato personale, URL inserito, referrer o testo libero nei parametri applicativi.
    const safe = {};
    if (["store", "lead", "nosite", "esempio"].includes(parameters.mode)) safe.mode = parameters.mode;
    if (["A", "B", "C"].includes(parameters.variant)) safe.variant = parameters.variant;
    gaEvent(name === "form_submit" ? "generate_lead" : name, safe);
    if (name !== "form_submit" || !consent.marketing || !config.enabled) return;
    if (adsReady()) window.gtag?.("event", "conversion", { send_to: `${config.google_ads_id}/${config.google_ads_label}`, page_location: canonicalUrl(path), page_referrer: "" });
    if (config.meta_pixel_id) window.fbq?.("track", "Lead");
    if (config.tiktok_pixel_id) window.ttq?.track?.("SubmitForm");
};